import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { sharedABQueryKeys } from 'pages/audience/shared/utilities';
import { audienceService } from 'services';
import { IResult } from 'types/api/common';
import { ITag } from 'types/api/tag';

export const useFetchMailTags = () => {
  return useQuery({
    queryFn: async () => await audienceService.getMailTags(),
    queryKey: sharedABQueryKeys.tags.mail,
    select: useCallback((data: IResult<ITag[]> | undefined) => data?.dataContainer ?? [], []),
  });
};
